import { v4 as uuidv4 } from 'uuid'
import { uploadDocuments } from '../../../actions'
import {
  validateFiles,
  optimizeImage,
  autoDetectFileType,
} from '../../../services'
import { normalizeFile } from '../../../utils/filename-utils'

/**
 * Belge yükleme metodlarını oluşturur
 *
 * @param {Object} state - Uygulama state
 * @param {Object} services - Servisler
 * @returns {Object} Belge yükleme metodları
 */
export const createDocumentUploadMethods = (state, services) => {
  const {
    files,
    isLoading,
    isUploadDisabled,
  } = state

  const {
    assetStore,
    axios,
    settings,
    responseHandlerService,
  } = services

  /**
   * Hazırlanan dosyaları yükle
   */
  const handleUploadFiles = async () => {
    if (isUploadDisabled.value) return

    isLoading.value = true

    try {
      // Dosyaları yükle
      await uploadDocuments({
        axios,
        settings,
        assetId: assetStore.assetId,
        files: files.value,
      })

      responseHandlerService.handleSuccess('Dosyalar başarıyla yüklendi')
      files.value = []

      // loadDocuments fonksiyonu dışarıdan enjekte edilecek (bağımlılık döngüsünü önlemek için)
    } catch (error) {
      responseHandlerService.handleError(error, 'Dosyalar yüklenirken bir hata oluştu')
    } finally {
      isLoading.value = false
    }
  }

  /**
   * Dosyaları doğrula ve hazırla
   * @param {Array} rawFiles - İşlenecek ham dosyalar
   */
  const validateAndPrepareFiles = async (rawFiles) => {
    // Dosyaları doğrula
    const validation = validateFiles(rawFiles)

    if (!validation.valid) {
      validation.errors.forEach(error => {
        responseHandlerService.handleWarning(error)
      })
      return null
    }

    // Önce dosya adlarını normalize et - Türkçe karakter sorunu için
    const normalizedFiles = validation.filesToProcess.map(file => normalizeFile(file))

    // Dosyaları işle ve optimize et
    const processedFiles = await Promise.all(
        normalizedFiles.map(async (file) => {
          // Eğer görsel dosyasıysa optimize et
          if (file.type.startsWith('image/')) {
            return await optimizeImage(file)
          }
          return file
        }),
    )

    return processedFiles
  }

  /**
   * Yükleme için dosyaları işle
   * @param {Array} rawFiles - İşlenecek ham dosyalar
   */
  const processUploadFiles = async (rawFiles) => {
    if (!rawFiles || rawFiles.length === 0) return

    try {
      // Set status to processing
      isLoading.value = true

      const processedFiles = await validateAndPrepareFiles(rawFiles)
      if (!processedFiles) {
        isLoading.value = false
        return
      }

      // Meta verilerle dosya nesneleri oluştur
      const newFiles = processedFiles.map(file => ({
        id: uuidv4(),
        file,
        name: file.name,
        description: '',
        categoryIds: [], // Boş dizi olarak başlat
        fileType: autoDetectFileType(file) || null,
      }))

      // Yeni dosyaları mevcut listeye ekle
      files.value = [...files.value, ...newFiles]
    } catch (error) {
      console.error('Error processing files:', error)
      responseHandlerService.handleError(error, 'Dosyalar işlenirken bir hata oluştu')
    } finally {
      // Reset loading state
      isLoading.value = false
    }
  }

  // Public API
  return {
    handleUploadFiles,
    processUploadFiles,
  }
}